import GenericTemplate from "../Common/GenericTemplate";

// the sub-path and sub-components mapping are in src/Config/routes.js
const DataPage = () => {
  const menuItems = [
    { label: "Files", icon: "pi pi-folder", path: "files" },
  ];

  return <GenericTemplate menuItems={menuItems} />;
};

export default DataPage;